const STATE_BOX = 'wysiwyg.viewer.components.StateBox'

export const stateBoxFormStateMetaData = {
    enforceContainerChildLimitsByWidth: true,
    enforceContainerChildLimitsByHeight: true,
    allowedParentTypes: [STATE_BOX]
}
